import React from 'react';
import { connect } from 'react-redux';
import OpeningChildNodes from '../animations/OpeningChildNodes'
import DraggingChildNodes from '../animations/DraggingChildNodes'
import ClosingChildNodes from '../animations/ClosingChildNodes'

const ChildNodes = props => {
  const { id, client, parent, root, page } = props
  if (client.status[parent]==='opening') {
    return (
      <div>
        <OpeningChildNodes id={id} parent={parent} page={page} root={root} />
      </div>
    )
  }
  if (client.status[parent]==='closing') {
    return (
      <div>
        <ClosingChildNodes id={id} parent={parent} page={page} root={root} />
      </div>
    )
  }
  return(
    <div>
      <DraggingChildNodes id={id} parent={parent} page={page} root={root} />
    </div>
  )
}

const mapStateToProps = state => ({
  client: state.client,
});

export default connect(mapStateToProps)(ChildNodes);



// WEBPACK FOOTER //
// ./src/components/nodes/ChildNodes.js